import SidebarItem_vue_vue_type_script_setup_true_lang_default from "./SidebarItem.vue.script.js";
//#region src/components/SidebarItem.vue
var SidebarItem_default = SidebarItem_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { SidebarItem_default as default };

//# sourceMappingURL=SidebarItem.vue.js.map